import { type PlatformType } from '@alfa-bank/newclick-types';
import { atom } from 'jotai';

export const platformAtom = atom<PlatformType>('mobile');
